// 2026-09-24 - FormuLearning - 주성분 확정 신호 (이슈 #75 G4, M915-04)
// 파일 위치: frontend/src/stores/substanceSyncStore.ts
// 목적: Step 3 에서 주성분을 확정하면(BR-STEP-03) 함께 마운트된 Step 1 카드가 확정 시각을
//       다시 읽어 재검색·이력 복원을 막게 한다(lotStore 와 같은 revision 방식).

import { create } from 'zustand'

interface SubstanceSyncState {
  /** 주성분 확정이 일어날 때마다 증가. 구독자는 변경 시 서버 재조회한다. */
  revision: number
  bump: () => void
}

export const useSubstanceSync = create<SubstanceSyncState>((set) => ({
  revision: 0,
  bump: () => set((s) => ({ revision: s.revision + 1 })),
}))
